
    export default {
        head: function () {
            return {
                title: this.$store.state.esProjektaiPageData.meta_title || this.$nuxt.$options.head.title,
                meta: [
                    { hid: 'description', name: 'description', content: this.$store.state.esProjektaiPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },

                    { hid: 'og:title', property: 'og:title', content: this.$store.state.esProjektaiPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'og:description', property: 'og:description', content: this.$store.state.esProjektaiPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'og:image', property: 'og:image', content: this.$store.state.esProjektaiPageData.background_image },

                    { hid: 'twitter:title', name: 'twitter:title', content: this.$store.state.esProjektaiPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'twitter:description', name: 'twitter:description', content: this.$store.state.esProjektaiPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'twitter:image', name: 'twitter:image', content: this.$store.state.esProjektaiPageData.background_image }
                ],
            };
        },
        computed: {
            esProjektaiPageData() {
                return this.$store.state.esProjektaiPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/1412`)
                .then((response) => {
                    context.store.dispatch("setEsProjektaiPageData", {
                        ...response.data.acf,
                        wpcontent: response.data.content.rendered,
                    })
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
